import { Content } from "../../squidex";

export class PageModel extends Content {

    constructor(current?: Content) {
        super(current);
        if (current) {
            Object.assign(this, current);
        }
    }
}
